<template>
  <h3 class="title">
    {{ title }}
  </h3>
</template>

<script>
export default {
  name: "MyTitle",
  props: {
    title: {
      type: String,
      required: true,
      default: '标题'
    }
  },
}
</script>

<style scoped lang="scss">
$color1: #28cccb;

h3.title {
  border-left: 5px solid $color1;
  padding-left: 10px;
}
</style>
